import { render } from "./ActionMessage.vue?vue&type=template&id=011c90e4"
import script from "./ActionMessage.vue?vue&type=script&lang=js"
export * from "./ActionMessage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/antoniokatarov/PhpstormProjects/WEBIS WHS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__